import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Card } from 'react-bootstrap';

/*
 * Apertura ticket di assistenza dentro il Manager, con il widget di LUME (lo stesso usato dai siti:
 * contenitore + ticket-widget.js con data-site="sportid-manager" e data-target sul contenitore).
 *
 * L'utente e' gia' loggato: nome, cognome ed email si precompilano dai dati della sessione.
 * Il widget non ha (ancora) un'opzione per i valori iniziali, ma disegna il modulo appena lo
 * script si carica con campi dagli id fissi (tkw-name, tkw-lastname, tkw-email) e legge i valori
 * all'invio: li riempiamo subito dopo il caricamento. Restano modificabili.
 */
const WIDGET_SRC = 'https://lume.applia.it/widget/ticket-widget.js';

const datiUtente = () => {
	try {
		const d = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
		const parti = String(d.displayName || '').trim().split(/\s+/).filter(Boolean);
		return {
			nome: parti.slice(0, 1).join(' '),
			cognome: parti.slice(1).join(' '),
			email: d.email || '',
		};
	} catch (e) {
		return { nome: '', cognome: '', email: '' };
	}
};

const imposta = (id, valore) => {
	const campo = document.getElementById(id);
	if (!campo || !valore || campo.value) return;
	campo.value = valore;
	campo.dispatchEvent(new Event('input', { bubbles: true }));
};

const TicketPage = () => {
	const contenitore = useRef(null);
	const navigate = useNavigate();
	const { pathname } = useLocation();

	useEffect(() => {
		const target = contenitore.current;
		if (!target) return undefined;

		// Ogni apertura ha il suo contenitore con un id unico (data-target dello script). In sviluppo
		// React monta la pagina due volte: il primo script, tolto dalla pulizia, viene eseguito lo
		// stesso dal browser e con un id fisso disegnava un secondo modulo nello stesso riquadro. Cosi'
		// trova il suo contenitore gia' rimosso e non disegna niente.
		const idContenitore = `ticket-widget-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
		const segnaposto = document.createElement('div');
		segnaposto.id = idContenitore;
		target.appendChild(segnaposto);

		const script = document.createElement('script');
		script.src = WIDGET_SRC;
		script.setAttribute('data-site', 'sportid-manager');
		script.setAttribute('data-target', idContenitore);
		script.async = true;
		script.onload = () => {
			if (!segnaposto.isConnected) return;
			const { nome, cognome, email } = datiUtente();
			imposta('tkw-name', nome);
			imposta('tkw-lastname', cognome);
			imposta('tkw-email', email);
		};
		document.body.appendChild(script);

		// Invio riuscito: il widget lo annuncia con un evento. Si apre la pagina di ringraziamento del
		// Manager con la navigazione interna; preventDefault() ferma l'eventuale redirect del widget,
		// che ricaricherebbe tutta l'app.
		const inviato = (evento) => {
			evento.preventDefault();
			navigate(`${pathname.replace(/\/$/, '')}/grazie`);
		};
		segnaposto.addEventListener('ticket-widget:inviato', inviato);

		return () => {
			segnaposto.removeEventListener('ticket-widget:inviato', inviato);
			script.remove();
			segnaposto.remove();
		};
	}, [navigate, pathname]);

	return (
		<Card>
			<Card.Body>
				<div ref={contenitore} />
			</Card.Body>
		</Card>
	);
};

export default TicketPage;
